export enum InvoiceActions {
  GET_INVOICE_LIST = 'invoice/GET_INVOICE_LIST',
}
